import React, { useState, useEffect } from "react";
import { format, parse } from "date-fns";
import MasterTable from "../../../components/common/MasterTable";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import { apiList } from "../../../helpers/apiList";
import CustomAlert from "../../../helpers/CustomAlert";
import Loader from "../../../components/Loader/Loader";
import VegaahUploadReportModal from "../../../components/VegaahUploadReport/VegaahUploadReportModal";
import HeaderWithBreadcrumb from "../../../components/common/HeaderWithBreadcrumb";

const defaultFilterData = {
  sendorId: "",
  templateId: "",
  status: [],
  fromDate: "",
  toDate: "",
};

const UploadVegaahReport = () => {
  const pageSize = 10;
  const loggedInUserName = sessionStorage.getItem("username");

  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [modalAction, setModalAction] = useState("");
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);
  const [pageDetails, setPageDetails] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);

  const handleReset = () => {
    setFilterData(defaultFilterData);
    fetchVegaahReportData(1, defaultFilterData);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  useEffect(() => {
    fetchVegaahReportData(1, filterData);
  }, []);

  const fetchVegaahReportData = async (currentPage, filters = filterData) => {
    try {
      const requestBody = {
        username: loggedInUserName,
        // status: filters.status || [],
        // fromDate: filters.fromDate ? formatDate(filters.fromDate) : "",
        // toDate: filters.toDate ? formatDate(filters.toDate) : "",
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_VEGAAH_REPORT_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);

        const modifiedData = modifyStructure(response?.data?.data);

        setData(modifiedData);
        if (modifiedData?.length === 0) {
          setNoData(true);
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setData([]);

        if (response?.data?.data !== null) {
          CustomAlert({
            title: "No Data",
            text: "No data available for the specified criteria.",
            icon: "info",
            confirmButtonText: "Okay",
          });
        }
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      }).then((result) => {
        if (result.isConfirmed) {
          sessionStorage.clear();
          window.location.href = "/";
        }
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    const modified = response?.map((user, index) => {
      const uploadedDateParsed = user?.uploadedDate
        ? parse(user.uploadedDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      const updatedDateParsed = user?.updatedDate
        ? parse(user.updatedDate, "dd-MM-yyyy HH:mm:ss", new Date())
        : null;

      return {
        ...user,
        uploadedDate: uploadedDateParsed
          ? format(uploadedDateParsed, "dd-MM-yyyy HH:mm:ss")
          : "",
        updatedDate: updatedDateParsed
          ? format(updatedDateParsed, "dd-MM-yyyy HH:mm:ss")
          : "",
      };
    });

    return modified;
  };

  const userHeaders = [
    "Req Date",
    "Uploaded By",
    "File Name",
    "Status",
    "Download Report",
    "Process",
  ];

  const userHeaderToKeyMap = {
    "Req Date": "uploadedDate",
    "Uploaded By": "uploadedBy",
    "File Name": "fileName",
    "Status": "status",
    "Download Report": "download",
    "Process": "process",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handleUser = (data, actionType = "view") => {
    setModalAction(actionType);
    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else if (actionType === "process"){
      if(data?.status === "PROCESSED" 
        || data?.status === "IN_PROGRESS"
      ){
        CustomAlert({
        title: "Process Confirmation",
        text: "Are you sure you want to process this file?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, Process it!",
        cancelButtonText: "No, Cancel",
      }).then((result) => {
        if (result.isConfirmed) {
          vegaahReportReconcile(data);
        }})
    } else{
      CustomAlert({
        title: "Process Status",
        text: "Report already reconciled.",
        icon: "info",
        confirmButtonText: "OK",
      })
    }
  }
    else {
      let smsDataL = data?.find((item) => item?.id === data?.id);
      if (smsDataL) {
        setEditData(smsDataL);
        setShowModal(true);
      }
    }
  };

const handleDownload = (rowData) => {
  const url = rowData?.downloadUrl || "";
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", "");
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

  const vegaahReportReconcile = async (item) => {
    try {

      const response = await axiosPostApi(
        `${apiList.VEGAAH_REPORT_RECONCILE}/${item?.id}?username=${loggedInUserName}`);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        fetchVegaahReportData(currentPage, filterData);
      } else{
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "An error occurred while processing the file.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      })
    } finally {
      setLoading(false);
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <>
    <HeaderWithBreadcrumb title="Upload Card RAW File" breadcrumb="Report" />
    <div>
    <div className="bg-[#FFFFFF] shadow-custom rounded-[14px] px-[10px] py-[10px]">
      {loading ? (
        <div className="flex justify-center items-center py-10">
            <Loader />
        </div>
      ) : (
        <>
          <MasterTable
            loading={loading}
            pageDetails={pageDetails}
            headers={userHeaders}
            data={data}
            handleAction={handleUser}
            filterFields={["templateId"]}
            entityType="Vegaah Bulk Upload"
            headerToKeyMap={userHeaderToKeyMap}
            noData={noData}
            // handleAuth={handleAuthorization}
            currentPage={currentPage}
            pageSize={pageSizeCount}
            totalRecord={totalRecord}
            fetchNextData={fetchVegaahReportData}
            setCurrentPage={setCurrentPage}
            setRowData={handleDownload}
            openModalFilter={openModalFilter}
            handleReset={handleReset}
            filterData={filterData}
            fetchData={() => {}}
          />
          <VegaahUploadReportModal
            show={showModal}
            handleClose={handleCloseModal}
            callApi={() => fetchVegaahReportData(1)}
          />
          {/* {isModalOpenFilter ? (
            <BulkFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setSmsData={setData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
            />
          ) : null} */}
        </>
      )}
      </div>
    </div>
    </>
  );
};

export default UploadVegaahReport;
